import React, { useCallback } from 'react'
import PropTypes from 'prop-types'

import { getUpdatedSegment, DEFAULT_SEGMENTATION_VERSION } from './segment-service'
import { Context } from './Context'

const SegmentSelector = ({ segment, onChange, children }) => {
  const changeSegment = useCallback(
    (criteria, Name, values, operation) => {
      const updatedSegment = getUpdatedSegment(segment, criteria, Name, values, operation)
      onChange(updatedSegment)
    },
    [onChange, segment],
  )

  const updateSegment = useCallback(
    (newSegment) => {
      onChange(newSegment)
    },
    [onChange],
  )

  return (
    <Context.Provider
      value={{
        segment,
        onChange: changeSegment,
        updateSegment,
      }}
    >
      {children}
    </Context.Provider>
  )
}

SegmentSelector.propTypes = {
  children: PropTypes.node,
  trigger: PropTypes.string,
  version: PropTypes.number,
  defaultMust: PropTypes.object,
  defaultOneOf: PropTypes.object,
  segment: PropTypes.object,
  onChange: PropTypes.func.isRequired,
}

SegmentSelector.defaultProps = {
  version: DEFAULT_SEGMENTATION_VERSION,
}

export default SegmentSelector

export { default as EngagementStageSelector } from './EngagementStageSelector'
export { default as InterestsSegmentSelector } from './InterestsSegmentSelector'
export { default as AcademicFocusSelector } from './AcademicFocusSelector'
export { default as CareerSelector } from './CareerSelector'
export { default as GraduationYearSelector } from './GraduationYearSelector'
export { default as UserTypeSelector } from './UserTypeSelector'
export { default as ManualStudentSelector } from './ManualStudentSelector'
export { default as LocationSelector } from './LocationSelector'
export { default as FirstGenSelector } from './FirstGenSelector'
export { default as HighSchoolSegmentSelector } from './HighSchool'
export { default as AcademicProfileSelector } from './AcademicProfile/AcademicProfileSelector'
export { default as DemographicsSelector } from './DemographicsSelector'
export { default as FocusAndCareerSelector } from './FocusAndCareerSelector'
export { LegalSexSection } from './LegalSexSelector'